import { createFileRoute } from '@tanstack/react-router'
import { AdminGuard } from '@/components/admin-guard'
import { ContractSlaView } from '@/features/clients/ContractSlaView'

function ContractSlaRoute() {
  const { companyId } = Route.useParams()
  return (
    <AdminGuard>
      <ContractSlaView companyId={companyId} />
    </AdminGuard>
  )
}

export const Route = createFileRoute('/clients/$companyId/contract-sla')({ component: ContractSlaRoute })
